import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../features/auth/authSlice";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import { collection, query, where, getDocs, Timestamp } from "firebase/firestore";
import { db } from "../../../config/firebase";

const Header = ({ onNote }) => {
  const { t, i18n } = useTranslation();
  const [hasImmediateActivity, setHasImmediateActivity] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLogout = async () => {
    await dispatch(logout());
    navigate("/login");
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("language");
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
  }, [i18n]);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const fetchImmediateActivities = async () => {
      if (!user) return;
      const now = new Date();
      const in30Min = new Date(now.getTime() + 30 * 60000);
      const q = query(
        collection(db, "meetings"),
        where("startDate", ">=", Timestamp.fromDate(now)),
        where("startDate", "<=", Timestamp.fromDate(in30Min))
      );
      const snapshot = await getDocs(q);
      const results = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter(
          (activity) =>
            activity.users?.includes(user.uid) || activity.adminUsers?.includes(user.uid)
        );
      setHasImmediateActivity(results.length > 0);
    };
    fetchImmediateActivities();
    const interval = setInterval(fetchImmediateActivities, 60 * 1000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <Link onClick={() => navigate(-1)} className="nav-item me-3">
                <i className="fa fa-arrow-left me-3" aria-hidden="true"></i>
              </Link>
            </div>

            <ul className="navbar-nav header-right main-notification align-items-center">
              <li className="nav-item dropdown me-3">
                <a
                  // href="#!"
                  className="nav-link dropdown-toggle d-flex align-items-center"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  🌐{" "}
                  <span className="ms-1">
                    {i18n.language === "tr" ? "Türkçe" : "English"}
                  </span>
                </a>

                {dropdownOpen && (
                  <ul
                    className="dropdown-menu show"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "white",
                      minWidth: "140px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      borderRadius: "6px",
                      zIndex: 9999,
                    }}
                  >
                    <li>
                      <a
                        // href="#!"
                        className="dropdown-item"
                        onClick={() => changeLanguage("tr")}
                      >
                        🇹🇷 Türkçe
                      </a>
                    </li>
                    <li>
                      <a
                        // href="#!"
                        className="dropdown-item"
                        onClick={() => changeLanguage("en")}
                      >
                        🇬🇧 English
                      </a>
                    </li>
                  </ul>
                )}
              </li>

              <Link to="/MyBusiness" className="nav-item me-3">
                <i className="fa fa-building me-3" aria-hidden="true"></i>
                <span className="ms-2">{t("business")}</span>
              </Link>
              <Link to="/MyProfile" className="nav-item me-3">
                <i className="fa fa-user me-3" aria-hidden="true"></i>
                <span className="ms-2">{t("profile")}</span>
              </Link>

              <Link className="nav-item me-3" onClick={onLogout}>
                <i className="fa fa-power-off me-3" aria-hidden="true"></i>
                <span className="ms-2">{t("logout")}</span>
              </Link>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
